import queryString from "query-string";
import { cache } from "react";

import { getAppUrl } from "@/helper/url";

import { propertiesCitiesCountSchema } from "@/schemas/properties";

import type { HouseCityParam, Uf } from "@/types";

const url = `${getAppUrl()}/api/properties`;

export const fetchPropertiesUfCities = async (uf: Uf["uf"]) => {
  try {
    const response = await fetch(`${url}/${uf}/cities`);

    if (!response.ok) {
      throw new Error("Erro ao buscar cidades por UF");
    }

    const data = await response.json();

    return propertiesCitiesCountSchema.parse(data);
  } catch (error) {
    console.error("Erro ao buscar cidades por UF:", error);
    throw new Error(
      error instanceof Error ? error.message : "Erro ao buscar cidades por UF"
    );
  }
};

export const postDownloadProperties = async (uf: Uf["uf"], email?: string) => {
  const response = await fetch(`${url}/download`, {
    method: "POST",
    body: JSON.stringify({ uf, email }),
  });

  if (!response.ok) {
    throw new Error("Erro ao baixar planilha");
  }

  const data = await response.json();

  return data;
};

export const fetchProperties = cache(
  async ({
    filters,
    options,
  }: {
    filters: HouseCityParam;
    options?: RequestInit;
  }) => {
    const searchParams = queryString.stringify(filters, {
      arrayFormat: "comma",
      skipEmptyString: true,
      skipNull: true,
    });

    try {
      const response = await fetch(
        `${url}/${filters.uf}?${searchParams}`,
        options
      );

      if (!response.ok) {
        throw new Error("Erro ao buscar imóveis");
      }

      const data = await response.json();

      return data;
    } catch (error) {
      console.error("Erro ao buscar imóveis:", error);
      throw new Error(
        error instanceof Error ? error.message : "Erro ao buscar imóveis"
      );
    }
  }
);
